import * as React from 'react';
import styled from 'styled-components';
import calcrem from '@adecco/base-app/src/utilities/calcrem/calcrem';
import { moreThan } from '@adecco/base-app/src/constants/breakpoints/breakpoints';
import Headline from '@adecco/base-app/src/components/atoms/Headline/Headline';
import { CloudinaryImageType } from '@adecco/base-app/src/gql/schema/generated';
import DynamicImage from '@adecco/base-app/src/components/atoms/DynamicImage/DynamicImage';

export interface IBenefit {
  name: string;
  icon?: string;
  cloudinaryImage?: CloudinaryImageType;
}

const BenefitStyled = styled.div`
  background-color: ${(props) => props.theme.backgrounds.benefit};
  box-shadow: ${(props) => props.theme.boxShadow.materialUp};
  border-radius: ${(props) => props.theme.radius.panel};
  height: 210px;
  padding: ${calcrem(34)} ${calcrem(24)} ${calcrem(60)};
  text-align: center;

  ${moreThan('md')} {
    box-shadow: ${(props) => props.theme.boxShadow.materialUpWideScreen};
    height: 260px;
    padding: ${calcrem(40)} ${calcrem(42)} ${calcrem(64)};
  }
`;

const BenefitIcon = styled.div`
  margin-bottom: ${calcrem(20)};
`;

const BenefitHeadline = styled(Headline)`
  color: ${(props) => props.theme.colors.benefitHeadline};
  font-family: ${(props) => props.theme.fonts.HeadlineBold};
  font-size: ${(props) => props.theme.fontSizes.benefitHeadline};
  line-height: ${(props) => props.theme.lineHeights.benefitHeadline};
  margin: 0;

  ${moreThan('md')} {
    font-family: ${(props) => props.theme.fonts.Headline};
    font-size: ${(props) => props.theme.fontSizes.benefitHeadlineWideScreen};
    line-height: ${(props) => props.theme.lineHeights.benefitHeadlineWideScreen};
  }
`;

const BenefitImage = styled(DynamicImage)`
  height: 54px;
  aspect-ratio: 1;
  object-fit: contain;
  width: auto;
`;

const Benefit: React.FunctionComponent<IBenefit> = ({ name, icon, cloudinaryImage }) => (
  <BenefitStyled>
    <BenefitIcon>
      <BenefitImage image={icon} cloudinaryImage={cloudinaryImage} alt={name} />
    </BenefitIcon>
    <BenefitHeadline skin={3} tag="h4">
      {name}
    </BenefitHeadline>
  </BenefitStyled>
);

export default Benefit;
